import type { TutorTask, TutorTaskStorePayload } from '../../model/tutor-tasks/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorTaskStoreApiOptions {
  payload: TutorTaskStorePayload
  onStart?: () => void
  onFinish?: () => void
}

/** `POST /admin-api/tutor-tasks` — creates a MANUAL task and answers with it. */
export const useTutorTaskStoreApi = async (options: TutorTaskStoreApiOptions): Promise<TutorTask | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutor-tasks.store')

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, options.payload)
    toast.success('The task was successfully create.')

    return data.data ?? null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    options.onFinish?.()
  }
}
